import React, { useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Badge, Modal, Steps, Tabs } from "antd";

import styled from "styled-components";
import Messages from "../../components/Messages/Messages";
// import { reservations } from "../../data/reservations-dummy-data";
import "./ReservationList.css";
import Card from "../../components/Card/Card";
import { submitCart, getClientProducts, openkit } from "../../library/database";
import Payment from "../Payment/Payment";
import TitleBanner from "../../components/TitleBanner/TitleBanner";
import Cart from "./Cart";
import UserMenu from "../User/UserMenu";
import LoginModal from "../User/LoginModal";
import { getLoggedInUser } from "../../library/user";
import Reservations from "./Reservations";
import Tickets from "./Tickets";
import History from "./History";
import UserInfo from "../User/UserInfo";
import { AppContext } from "../../context";
import { useLanguage } from "../../hooks/useLanguage";
import BackBtn from "../../components/Buttons/BackBtn";
import CarbonFootprintInquiry from "../../components/CarbonFootprintInquiry/CarbonFootprintInquiry";

export const Container = styled.div`
  width: 80%;
  max-width: 1100px;
  min-height: 500px;
  margin: 0 auto;
  font-family: "Open Sans", "sans-serif";
`;

const { TabPane } = Tabs;
const { Step } = Steps;

const PersonalArea = ({ match, history }) => {
  const [productsInCart, setProductsInCart] = useState([]);
  const [confirmedProducts, setConfirmedProducts] = useState([]);
  const [pendingProducts, setPendingProducts] = useState([]);
  const [paidProducts, setPaidProducts] = useState([]);
  const [deliveredProducts, setDeliveredProducts] = useState([]);
  const [updateList, setUpdateList] = useState(true);
  const [activeKey, setActiveKey] = useState("1");
  const [messagingPaneStoreSlug, setMessagingPaneStoreSlug] = useState(null);
  const info = useContext(AppContext);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentMenu, setCurrentMenu] = useState("personal-area");

  const [showCarbonFootprintInquiry, setShowCarbonFootprintInquiry] =
    useState(false);
  const [inquiry, setInquiry] = useState({});

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();

  const getLoggedInUserFn = async () => {
    const user = await getLoggedInUser();

    if (user) {
      info.setUser(user);
    }
  };

  useEffect(() => {
    let language = history.location.pathname.substring(1, 3);

    const languages = ["pt", "en", "fr", "es", "de"];

    if (languages.includes(language)) info.setLanguage(language);
    else info.setLanguage("pt");
  }, []);

  useEffect(() => {
    (async () => {
      // from confirmation email
      const confirmationId = match?.params?.id;
      if (confirmationId) {
        const user = await openkit.users.confirmEmail(confirmationId);
        if (user.token) {
          window.localStorage.setItem("openkit", user.token);

          if (user) {
            info.setUser(user);
            setActiveKey("1");
            setCurrentMenu("area-pessoal");
          }
        }

        return;
      } else {
        // get user from token in case user goes directly to this route
        const token = window.localStorage.getItem("openkit");

        if (token) getLoggedInUserFn();

        // set the tab based on URL query parameters
        const tab = query.get("tab");
        setActiveKey(tab ? tab : "1");

        const st = query.get("st");
        setMessagingPaneStoreSlug(st);

        const menu = query.get("seccao");

        if (menu === "info") {
          setCurrentMenu("info");
        } else {
          setCurrentMenu("area-pessoal");
        }
      }
    })();
  }, [updateList, info.updateComponent]);

  useEffect(() => {
    // periodic get of status
    getReservationStatus();
    const id = setInterval(() => {
      getReservationStatus();
    }, 3000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (Object.keys(inquiry).length) {
      // use first product reservation line to obtain reservation id
      try {
        (async () => {
          await openkit.data.create("c_trip_carbon", inquiry);
        })();
      } catch (error) {
        console.log("error :>> ", error);
      }
      // inquiry was filled, close window
      setShowCarbonFootprintInquiry(false);
    }
  }, [inquiry]);

  const handleSubmitCart = async () => {
    try {
      const resp = await submitCart(productsInCart);
      setProductsInCart([]);
      handleTabChange("2");
      setShowCarbonFootprintInquiry(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReservationStatus();
  }, [info.user?.id]);

  const getReservationStatus = async () => {
    if (info?.user?.id) {
      const products = await getClientProducts("all", info.user.id);
      if (products.length > 0) {
        const productsInCart = products.filter((p) => p.status === "cart");
        const pendingProducts = products.filter((p) => p.status === "pending");
        const confirmedProducts = products.filter(
          (p) => p.status === "confirmed"
        );
        const paidProducts = products.filter((p) => p.status === "paid");
        const deliveredProducts = products.filter(
          (p) => p.status === "delivered"
        );
        // const rejectedProducts = products.filter(p => p.status === 'rejected')

        setProductsInCart(productsInCart);
        setPendingProducts(pendingProducts);
        setConfirmedProducts(confirmedProducts);
        setPaidProducts(paidProducts);
        setDeliveredProducts(deliveredProducts);
      }

      // avance to tab 3 if tab 2 is empty
      if (
        activeKey === 1 &&
        pendingProducts.length === 0 &&
        confirmedProducts.length === 0 &&
        paidProducts.length > 0
      ) {
        setActiveKey(3);
        history.push(`/reservas?tab=3`);
      }
    }
  };

  const handleTabChange = async (tabNumber) => {
    setActiveKey(tabNumber);
    getReservationStatus();
    history.push(`/reservas?tab=${tabNumber}`);
  };

  return (
    <Container>
      {!info.user && (
        <TitleBanner
          color="green"
          title={info.t("loginOrRegister")}
          // subtitle={info.t("toBeAbleToReserveAndPurchase")}
        >
          <button
            className="ahp-button ahp-xl"
            type="button"
            style={{ margin: "1.7rem 1.5rem 1.7rem 1.5rem" }}
            onClick={() => setIsModalVisible(true)}
          >
            {info.t("loginRegister")}
          </button>
        </TitleBanner>
      )}
      <div
      // style={{
      //   display: "flex",
      //   justifyContent: "space-between",
      //   alignItems: "center",
      // }}
      >
        {/* <BackBtn history={history} /> */}

        {info.user && (
          <>
            <UserMenu updateList={updateList} setUpdateList={setUpdateList} />
          </>
        )}
      </div>
      {info.user && currentMenu === "area-pessoal" && (
        <>
          <Tabs onChange={handleTabChange} activeKey={activeKey}>
            <TabPane
              tab={
                <Badge count={productsInCart.length} offset={[8, -3]}>
                  {info.t("cart")}
                </Badge>
              }
              key="1"
            >
              <Cart
                productsInCart={productsInCart}
                handleSubmitCart={handleSubmitCart}
                history={history}
                updateList={updateList}
                setUpdateList={setUpdateList}
              />
            </TabPane>

            <TabPane
              tab={
                <Badge
                  count={pendingProducts.length + confirmedProducts.length}
                  offset={[8, -3]}
                >
                  {info.t("reservations")}
                </Badge>
              }
              key="2"
            >
              <Reservations
                confirmedProducts={confirmedProducts}
                pendingProducts={pendingProducts}
                updateList={updateList}
                setUpdateList={setUpdateList}
                setActiveKey={setActiveKey}
              />
            </TabPane>

            <TabPane
              tab={
                <Badge count={paidProducts.length} offset={[8, -3]}>
                  {info.t("tickets")}
                </Badge>
              }
              key="3"
            >
              <Tickets
                paidProducts={paidProducts}
                updateList={updateList}
                setUpdateList={setUpdateList}
              />
            </TabPane>

            <TabPane
              tab={
                <Badge count={deliveredProducts.length} offset={[8, -3]}>
                  {info.t("history")}
                </Badge>
              }
              key="4"
            >
              <History
                deliveredProducts={deliveredProducts}
                updateList={updateList}
                setUpdateList={setUpdateList}
              />
            </TabPane>
            {/* <TabPane
              tab={
                // <Badge count={deliveredProducts.length} offset={[8, -3]}>
                info.t("messages")
                // </Badge>
              }
              key="5"
            >
              <Messages messagingPaneStoreSlug={messagingPaneStoreSlug} />
            </TabPane> */}
          </Tabs>
        </>
      )}
      {info.user && currentMenu === "info" && (
        <>
          <UserInfo />
        </>
      )}
      {isModalVisible && (
        <LoginModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
        />
      )}
      {showCarbonFootprintInquiry && (
        <Modal
          className="ahp-modal"
          visible={showCarbonFootprintInquiry}
          footer={null}
          width="auto"
          style={{ maxWidth: "800px" }}
        >
          <CarbonFootprintInquiry setInquiry={setInquiry} />
        </Modal>
      )}
    </Container>
  );
};

export default PersonalArea;
